import { CHANGE_CONFIG, EXPORT_DONE, EXPORT_FAILED, EXPORT_BTN_CLICK, QUERY_STATE, CHANGE_FIX_DIMENSION, } from '../constants';
const initState = {
    queryState: QUERY_STATE.SUCCESS,
    isDimensionFixed: false,
    format: undefined,
};
export const actionBar = (state = initState, action) => {
    switch (action.type) {
        case CHANGE_CONFIG:
            return { ...initState };
        case EXPORT_BTN_CLICK:
            return { ...state, queryState: QUERY_STATE.WAITING };
        case EXPORT_DONE:
            return { ...state, queryState: QUERY_STATE.SUCCESS };
        case EXPORT_FAILED:
            return { ...state, queryState: QUERY_STATE.FAIL };
        case CHANGE_FIX_DIMENSION:
            return { ...state, isDimensionFixed: action.isDimensionFixed, format: action.format };
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map